/**
 * CostBadge — Live spend tracker in agent header
 *
 * Shows current cost, with color changes at 90% and 100% of limit.
 */
import type { CostInfo } from '../../engine/agentTypes'
import type { SpendWarning } from '../../hooks/useAgent'

interface CostBadgeProps {
    cost: CostInfo
    limit?: string  // softSpendUsd from config
    warning: SpendWarning
}

export function CostBadge({ cost, limit, warning }: CostBadgeProps) {
    const usd = cost.estimatedCostUsd.toFixed(3)
    const limitNum = limit ? parseFloat(limit) : null

    return (
        <span
            className={`cost-badge cost-${warning}`}
            title={`Input: ${cost.tokensIn} tokens · Output: ${cost.tokensOut} tokens`}
        >
            <span className="cost-amount">${usd}</span>
            {limitNum !== null && limitNum > 0 && (
                <span className="cost-limit"> / ${limitNum.toFixed(2)}</span>
            )}
        </span>
    )
}
